



















import { EditableLabel } from './editable-label';
export default EditableLabel;
